export const searchEngineDisabledPages: (string | RegExp)[] = [
  /\/nyheter\/.*?\/93872/g,
];
